import React from 'react'
import { Button } from '../../../components/Button/Button'
import { Modal } from '../../../components/Modal/Modal'

type RequestChangeSubject = 'details' | 'scopes'

const SUBJECT_TEXT: Record<RequestChangeSubject, string> = {
  details:
    "To request changes to your app details, email us at integrations@zocks.io and let us know what you'd like to change. We'll review it and get back to you.",
  scopes:
    "To request changes to your app's scopes, email us at integrations@zocks.io and let us know what you'd like to change. We'll review it and get back to you.",
}

interface RequestChangeModalProps {
  show: boolean
  subject: RequestChangeSubject
  onHide: () => void
}

export const RequestChangeModal: React.FC<RequestChangeModalProps> = ({ show, subject, onHide }) => (
  <Modal
    show={show}
    onHide={onHide}
    header='Request changes to your app'
    body={<p className='mb-0'>{SUBJECT_TEXT[subject]}</p>}
    footer={
      <div className='d-flex justify-content-end'>
        <Button variant='primary' onClick={onHide}>
          Close
        </Button>
      </div>
    }
  />
)
